<template>
  <v-btn class="error" @click="onDelete">Xoá sự kiện</v-btn>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions({ remove: 'events/remove' }),
    onDelete() {
      this.$dialog.confirm({
        title: 'Xác nhận xoá sự kiện',
        text:
          'Thao tác này sẽ xoá sự kiện và tất cả dữ liệu kèm theo sự kiện. Thao tác này sẽ không thể hoàn tác, bạn có chắc chắn muốn xoá?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(this.$route.params.id)
            this.$alert.success('Xoá sự kiện thành công')
            this.$router.push('/events')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>
